import { render } from "./FloatingBall.vue?vue&type=template&id=54585264&scoped=true"
import script from "./FloatingBall.vue?vue&type=script&lang=js"
export * from "./FloatingBall.vue?vue&type=script&lang=js"

import "./FloatingBall.vue?vue&type=style&index=0&id=54585264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54585264"]])

export default __exports__